<template>
  <div class="order-history-table border" role="table" :aria-label="label" :aria-busy="loading ? 'true' : 'false'" :style="{ '--history-columns': gridColumns }">
    <span v-if="loading" class="sr-only" role="status">購物紀錄載入中</span>
    <div class="history-heading history-row" role="row">
      <div v-for="column in columns" :key="column.key" class="history-title text-center" role="columnheader">{{ column.label }}</div>
    </div>
    <template v-if="loading">
      <div v-for="n in 5" :key="'loading-' + n" class="history-row history-body" aria-hidden="true">
        <div v-for="column in columns" :key="column.key" class="history-cell">
          <span class="mobile-label font-weight-bold">{{ column.label }}</span>
          <span class="history-skeleton"></span>
        </div>
      </div>
    </template>
    <div v-else v-for="row in rows" :key="row.id" class="history-row history-body position-relative fs-lg-16 fs-14" role="row">
      <div v-for="column in columns" :key="column.key" class="history-cell" :class="{ 'history-action': column.action }" role="cell">
        <span class="mobile-label font-weight-bold">{{ column.label }}</span>
        <div class="history-value">
          <slot :name="column.key" :row="row"><span>{{ formatCell(row, column.key) }}</span></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rows: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    label: { type: String, default: '購物紀錄' },
    formatCell: { type: Function, default: (row, key) => row[key] },
    gridColumns: { type: String, default: '2fr 2fr repeat(5, 1fr)' }
  }
}
</script>
<style scoped>
.history-row { display: grid; grid-template-columns: var(--history-columns); }
.history-title { padding: 12px 4px; }
.history-body { border-top: 1px solid rgba(216, 216, 216, .6); }
.history-cell { display: flex; align-items: center; justify-content: center; min-width: 0; padding: 16px 8px; }
.history-value { overflow-wrap: anywhere; text-align: center; }
.history-action { position: relative; z-index: 2; }
.mobile-label { display: none; }
.history-skeleton { display: block; width: 80%; max-width: 150px; height: 18px; border-radius: 4px; background: linear-gradient(90deg, #eee 25%, #f8f8f8 50%, #eee 75%); background-size: 200% 100%; animation: history-loading 1.4s ease-in-out infinite; }
@keyframes history-loading { to { background-position: -200% 0; } }
@media (prefers-reduced-motion: reduce) { .history-skeleton { animation: none; } }
@media (max-width: 991.98px) {
  .history-heading { display: none; }
  .history-row { grid-template-columns: 1fr; }
  .history-cell { display: grid; grid-template-columns: minmax(100px, 40%) minmax(0, 1fr); gap: 12px; padding: 8px 16px; }
  .history-body { padding: 8px 0; }
  .history-value { text-align: left; }
  .mobile-label { display: block; }
}
</style>
